import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbNavContent } from '@ng-bootstrap/ng-bootstrap';
import { NgForm, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
// import { Options } from 'Select2';
import { NgbDateStruct, NgbDatepickerI18n, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime } from 'rxjs/operators';
import { DateformatService } from '../../../util/dateformat.service';
import { I18n, CustomDatepickerI18n } from 'src/app/util/ngbd-datepicker-i18n/ngbd-datepicker-i18n.component';

import { Activity } from '@models/activity';


import { RequirementService } from 'src/app/services/requirement.service';
import { ActivitiesValidator } from "@flows/shared/pop-up/activity-alert/validation/activities.validator";
import { Subject, throwError } from 'rxjs';
import { forkJoin } from 'rxjs';

export interface Options {
  multiple: boolean;
  width: string;
  tags: boolean;
}
export interface TimeAlert {
  hour: number;
  minute: number;
  second: number;
}
export interface DateAlert {
  year: number,
  month: number,
  day: number,
};
@Component({
    selector: 'app-activity-alert',
    templateUrl: './activity-alert.component.html',
    styleUrls: ['./activity-alert.component.scss', '../alert/alert.component.scss'],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: DateformatService }
    ],
    standalone: false
})
export class ActivityAlertComponent implements OnInit {
  @Input() idactivityAlert: number;
  @Input() titelModal: string;
  @Input() edicion: boolean;
  @Input() requirementId: number;
  @Output() insertAlert = new EventEmitter<boolean>();
  activities: Activity = new Activity();
  multipleMultiSelect: string[] = [];
  collaborators: Array<any> = [];
  public activitiesForm: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  edicionPhatch: boolean = false;
  activities_validation_messages = ActivitiesValidator.ACTIVITIES_VALIDATION_MESSAGES;
  model1: NgbDateStruct = null;
  model2:  DateAlert[];
  activityTimeString: string = '';
  timeAlertStrings: string[] = [];
  mindate = undefined;
  maxdate = {};
  private _successActivity = new Subject<string>();
  private _errorActivity = new Subject<string>();
  successMessageActivity: string = '';
  errorMessageActivity: string = '';

  public repeatList: FormArray;
  get listAlerts() {
    return this.activitiesForm.get('alerts') as FormArray;
  }
  constructor(
    public activeModal: NgbActiveModal,
    // private collaboratorsService: CollaboratorsService,
    // private activitiesService: ActivitiesService,
    public _requirements: RequirementService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    const rawActivityId = this.idactivityAlert as number | string | null | undefined;
    const activityIdNum =
      rawActivityId != null && rawActivityId !== ''
        ? Number(rawActivityId)
        : NaN;

    this.activitiesForm = this.formBuilder.group({
      id: [{ value: activityIdNum, disabled: true }],
      subject: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(80)]],
      content: ['', [Validators.minLength(0), Validators.maxLength(250)]],
      date_activity: [null, [Validators.required]],
      hour_activity: [null, [Validators.required]],
      idsCollaborators: [[]],
      alerts: this.formBuilder.array([]),
    });

    // Edición: cargar lista de colaboradores y actividad juntos; si no, ng-select recibe ids antes que [items] y no muestra etiquetas.
    if (!Number.isNaN(activityIdNum)) {
      forkJoin({
        collaborators: this._requirements.getAllCollaboratorsData(),
        activity: this._requirements.geActivityById(this.requirementId, activityIdNum),
      }).subscribe({
        next: ({ collaborators, activity }) => {
          this.collaborators = collaborators['result'] ?? [];
          this.edicionPhatch = true;
          this.obtenerPatchActivity(activity['result']);
          this.cdr.detectChanges();
        },
        error: () => {
          this._errorActivity.next('Error al cargar la actividad.');
        },
      });
    } else {
      this.obtenerCollaborator();
    }
    const current = new Date();
    this.mindate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };


    this.model2 = [];
    this.timeAlertStrings = [];
    
    // Forzar detección de cambios al final de ngOnInit
    setTimeout(() => {
      this.cdr.detectChanges();
    });
    this.messageActivity();
  }

  createAlert(element): FormGroup {
    return this.formBuilder.group({
      id: [{ value: element.id ? element.id:null, disabled: true }],
      date_before_activity: [null],
      hour_before_activity: [null],
    });
  }

  addRepeat(e) {
    this.repeatList = this.activitiesForm.get('alerts') as FormArray;
    this.repeatList.push(this.createAlert({ id:null,date_before_activity: null}));
    this.timeAlertStrings.push('');
  }
  editRepeat(element) {
    this.repeatList = this.activitiesForm.get('alerts') as FormArray;
    this.repeatList.push(this.createAlert(element));
  }
  removeRepeat(index) {
    this.repeatList.removeAt(index);
    this.timeAlertStrings.splice(index,1);
    this.model2.splice(index,1);
  }
  
  // Manejar cambio de hora de actividad
  onActivityTimeChange(time: any) {
    if (!time) return;
    
    // Solo procesar si es un string del input type="time"
    if (typeof time === 'string' && time.includes(':')) {
      const [hours, minutes] = time.split(':');
      setTimeout(() => {
        this.activitiesForm.patchValue({
          hour_activity: {
            hour: parseInt(hours, 10),
            minute: parseInt(minutes, 10),
            second: 0
          }
        }, { emitEvent: false });
      });
    }
    // Si es un objeto, ignorarlo porque viene del patchValue
  }
  
  // Manejar cambio de hora de alerta
  onAlertTimeChange(index: number, time: any) {
    if (!time) return;
    
    // Solo procesar si es un string del input type="time"
    if (typeof time === 'string' && time.includes(':')) {
      const alertsArray = this.activitiesForm.get('alerts') as FormArray;
      const alertControl = alertsArray.at(index);
      const [hours, minutes] = time.split(':');
      
      alertControl.patchValue({
        hour_before_activity: {
          hour: parseInt(hours, 10),
          minute: parseInt(minutes, 10),
          second: 0
        }
      }, { emitEvent: false });
    }
    // Si es un objeto, ignorarlo porque viene del patchValue
  }

  obtenerCollaborator() {
    this._requirements.getAllCollaboratorsData().subscribe(
      data => {
        this.collaborators = data['result'];
        // Forzar detección de cambios después de cargar colaboradores
        setTimeout(() => {
          this.cdr.detectChanges();
        });
      },
      error => {
        this._errorActivity.next('Error al cargar los colaboradores.');
      }
    );
  }

  get f() { return this.activitiesForm.controls; }
  add() {
    this.loading = true;
    if (this.activitiesForm.invalid) {
      this.loading = false;
      return;
    }

    this.submitted = true;
    this.activities = this.activitiesForm.value;
    this.activities.id = this.idactivityAlert;
    this.activities.requirementid = this.requirementId;

    if(!this.isValidAlerts(this.activities)){
      this._errorActivity.next('Por favor, revise las alertas, para la configuracion de cada alerta se requiere la fecha y hora. ');
      this.submitted = false;
      this.loading = false;
      return;
    }

    if (this.edicion) {
      this.edit();
    } else if (this.idactivityAlert === null) {
      this.create();
    }

  }
  create() {
    let activitiesTem = new Activity();
    activitiesTem = this.changeObject(this.activities);
    this._requirements.createActivityAlertTrackvision(activitiesTem).subscribe(
      data => {
        this._successActivity.next('Se registró una actividad correctamente.');
        setTimeout(() => this.activeModal.dismiss(), 2000);
        setTimeout(() => this.insertAlert.emit(true), 2000);
        this.reiniciarFormulario();
      },
      error => {
        this._errorActivity.next('Error al crear la actividad.');
      });
  }

  edit() {
    let activitiesTem = new Activity();
    activitiesTem = this.changeObject(this.activities);

    this._requirements.editActivityAlertTrackvision(activitiesTem).subscribe(
      data => {
        this._successActivity.next('Se actualizó la actividad correctamente.');
        this.submitted = false;
        setTimeout(() => this.activeModal.dismiss(), 2000);
        setTimeout(() => this.insertAlert.emit(true), 2000);
      },
      error => {
        this._errorActivity.next('Error al actualizar la actividad.');
      });
  }

  reiniciarFormulario() {
    this.activities = new Activity();
    this.activitiesForm.reset();
    this.submitted = false;
  }
  obtenerPatchActivity(data) {
    this.activities = this.changeObject(data);
    
    // Convertir hora de actividad a string para input type="time"
    if (this.activities.hour_activity) {
      const timeObj = this.activities.hour_activity;
      if (typeof timeObj === 'object' && timeObj.hour !== undefined) {
        this.activityTimeString = `${String(timeObj.hour).padStart(2, '0')}:${String(timeObj.minute || 0).padStart(2, '0')}`;
      } else if (typeof timeObj === 'string') {
        const parts = timeObj.split(':');
        this.activityTimeString = `${parts[0]}:${parts[1]}`;
      }
    }
    
    const collabIds = this.normalizeCollaboratorIds(this.activities.idsCollaborators);
    const hourActivityObj = this.buildHourActivityFromTimeString(this.activityTimeString);

    this.activitiesForm.patchValue({
      id: this.activities.id,
      subject: this.activities.subject,
      content: this.activities.content,
      date_activity: this.activities.date_activity,
      hour_activity: hourActivityObj,
      idsCollaborators: collabIds,
      alerts: this.activities.alerts,

    });
    
    // Convertir horas de alertas a strings
    if (this.activities.alerts && this.activities.alerts.length > 0) {
      this.activities.alerts.forEach((alert, index) => {
        if (alert.hour_before_activity) {
          const timeObj = alert.hour_before_activity;
          if (typeof timeObj === 'object' && timeObj.hour !== undefined) {
            this.timeAlertStrings[index] = `${String(timeObj.hour).padStart(2, '0')}:${String(timeObj.minute || 0).padStart(2, '0')}`;
          } else if (typeof timeObj === 'string') {
            const parts = timeObj.split(':');
            this.timeAlertStrings[index] = `${parts[0]}:${parts[1]}`;
          }
        }
      });
    }
    
    // Forzar detección de cambios después de actualizar los valores
    this.cdr.detectChanges();
  }
  /** Mismo formato que onActivityTimeChange para que Validators.required en hour_activity sea coherente con el input type="time". */
  private buildHourActivityFromTimeString(timeStr: string | null | undefined): { hour: number; minute: number; second: number } | null {
    if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) {
      return null;
    }
    const [h, m] = timeStr.split(':');
    const hour = parseInt(h, 10);
    const minute = parseInt(m, 10);
    if (isNaN(hour) || isNaN(minute)) {
      return null;
    }
    return { hour, minute, second: 0 };
  }

  /** Coincide con bindValue="id" (número) en ng-select */
  private normalizeCollaboratorIds(ids: unknown): number[] {
    if (ids == null) return [];
    const arr = Array.isArray(ids) ? ids : [];
    return arr
      .map((x) => (typeof x === 'string' ? parseInt(x, 10) : Number(x)))
      .filter((n) => !isNaN(n));
  }

  formatDateEdit(date) {
    let dateTime = date.split('-');
    return {
      year: Number(dateTime[0]),
      month: Number(dateTime[1]),
      day: Number(dateTime[2].substring(0, 2)),
    };
  }
  formatTimeEdit(time) {
    let dateTime = time.split(':');
    return {
      hour: Number(dateTime[0]),
      minute: Number(dateTime[1]),
      second: Number(dateTime[2]),
    };
  }
  
  isValidAlerts(activities: Activity):boolean{
    let isValid = true;
    activities.alerts.forEach((element, index) => {
      if(!this.model2[index] || !this.timeAlertStrings[index] || this.timeAlertStrings[index] === ''){
        isValid = false;
      }
    });
    return isValid;
  }

  private pad2(n: number): string {
    return String(n).padStart(2, '0');
  }

  private formatDateStructToApi(d: NgbDateStruct | string | null | undefined): string {
    if (d == null || d === '') {
      return '';
    }
    if (typeof d === 'string') {
      return d.split('T')[0].trim();
    }
    if (typeof d === 'object' && d.year != null) {
      return `${d.year}-${this.pad2(d.month)}-${this.pad2(d.day)}`;
    }
    return '';
  }

  private formatHourForApi(timeStr: string | null | undefined): string | undefined {
    if (!timeStr || timeStr === '') {
      return undefined;
    }
    const parts = timeStr.split(':');
    if (parts.length >= 3) {
      return timeStr;
    }
    return `${parts[0]}:${parts[1]}:00`;
  }

  /**
   * Fecha (YYYY-MM-DD) y hora del formulario en reloj del navegador → ISO UTC.
   */
  private localWallClockToIsoUtc(dateYYYYMMDD: string, hourHHmmss: string | undefined | null): string | null {
    const datePart = (dateYYYYMMDD || '').split('T')[0].trim();
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(datePart);
    if (!m) {
      return null;
    }
    const y = +m[1];
    const mo = +m[2];
    const d = +m[3];
    const t = (hourHHmmss != null ? String(hourHHmmss) : '00:00:00').split(':');
    const hh = +t[0] || 0;
    const mi = +t[1] || 0;
    const ss = +t[2] || 0;
    const local = new Date(y, mo - 1, d, hh, mi, ss, 0);
    if (Number.isNaN(local.getTime())) {
      return null;
    }
    return local.toISOString();
  }

  /** Payload create/edit: legacy date+hour + activity_at / alert_at (navegador → UTC). */
  private applyDateHourFieldsForApi(activitiesTem: Activity, alerts: any[]): void {
    const dateStr = this.formatDateStructToApi(this.model1);
    if (dateStr) {
      activitiesTem.date_activity = dateStr;
    }
    const hourStr = this.formatHourForApi(this.activityTimeString);
    if (hourStr) {
      activitiesTem.hour_activity = hourStr;
    }
    const activityIso = this.localWallClockToIsoUtc(dateStr, hourStr);
    if (activityIso) {
      activitiesTem.activity_at = activityIso;
    } else {
      delete activitiesTem.activity_at;
    }

    if (!alerts?.length) {
      activitiesTem.alerts = alerts || [];
      return;
    }

    activitiesTem.alerts = alerts.map((element, index) => {
      const alertDate = this.formatDateStructToApi(this.model2[index]);
      const alertHour = this.formatHourForApi(this.timeAlertStrings[index]);
      const row: Record<string, unknown> = {
        ...element,
        date_before_activity: alertDate,
        hour_before_activity: alertHour,
      };
      const alertIso = this.localWallClockToIsoUtc(alertDate, alertHour);
      if (alertIso) {
        row['alert_at'] = alertIso;
      } else {
        delete row['alert_at'];
      }
      const ctrlId = this.listAlerts?.controls[index]?.['controls']?.id?.value;
      if (ctrlId != null && ctrlId !== '') {
        row['id'] = ctrlId;
      } else if (element.id != null) {
        row['id'] = element.id;
      }
      return row;
    });
  }

  changeObject(activities: Activity) {
    let activitiesTem: Activity = new Activity();
    if (this.edicionPhatch) { // edit
      let activity = activities.activities;
      this.multipleMultiSelect = [];
      if (activity[0].activity_at) {
        const d = new Date(activity[0].activity_at as string);
        if (!Number.isNaN(d.getTime())) {
          this.model1 = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
          this.activityTimeString = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        }
      }
      if (!this.model1) {
        this.model1 = this.formatDateEdit(activity[0].date_activity);
      }
      if (!this.activityTimeString && activity[0].hour_activity) {
        const parts = String(activity[0].hour_activity).split(':');
        this.activityTimeString = `${parts[0]}:${parts[1]}`;
      }
      if (activities.collaborators && activities.collaborators.length > 0) {
        activities.collaborators.forEach((element) => {
          this.multipleMultiSelect.push(String(element.userid));
        });
      }

      if (activities.alerts.length > 0) {
        this.timeAlertStrings = [];
        this.model2 = [];
        activities.alerts.forEach((element, index) => {
          if (element.alert_at) {
            const ad = new Date(element.alert_at as string);
            if (!Number.isNaN(ad.getTime())) {
              this.model2.push({
                year: ad.getFullYear(),
                month: ad.getMonth() + 1,
                day: ad.getDate(),
              });
              this.timeAlertStrings.push(
                `${String(ad.getHours()).padStart(2, '0')}:${String(ad.getMinutes()).padStart(2, '0')}`
              );
            }
          }
          if (!this.model2[index]) {
            if (element.hour_before_activity) {
              const parts = String(element.hour_before_activity).split(':');
              this.timeAlertStrings.push(`${parts[0]}:${parts[1]}`);
            } else {
              this.timeAlertStrings.push('');
            }
            const date = this.formatDateEdit(element.date_before_activity);
            this.model2.push(date);
          }
          element.date_before_activity = this.model2[index];
          element.id = activities.alerts[index].id;
          this.editRepeat(element);
        });
      }

      activitiesTem.alerts = activities.alerts;
      activitiesTem.id = activity[0].id;
      activitiesTem.requirementid = this.requirementId;
      activitiesTem.subject = activity[0].subject;
      activitiesTem.content = activity[0].content;
      activitiesTem.idsCollaborators = this.multipleMultiSelect;

      this.edicionPhatch = false;
    } else { // add
      activitiesTem.alerts = activities.alerts;
      activitiesTem.id = activities.id;
      activitiesTem.requirementid = this.requirementId;
      activitiesTem.subject = activities.subject;
      activitiesTem.content = activities.content;
      activitiesTem.idsCollaborators = activities.idsCollaborators;
    }

    // Envío create/edit (no carga desde API).
    if (!Array.isArray(activities.activities)) {
      this.applyDateHourFieldsForApi(
        activitiesTem,
        activitiesTem.alerts ?? activities.alerts
      );
    }

    return activitiesTem;
  }

  change(e) {
    // this.submitted = false;
    if (e != null) {
      this.maxdate = {
        year: Number(e.year),
        month: Number(e.month),
        day: Number(e.day),
      };
      this.activitiesForm.patchValue({
        date_activity: e.year + '-' + e.month + '-' + e.day
      });
    }
  }
  messageActivity() {
    // messages
    this._successActivity.subscribe(message => this.successMessageActivity = message);
    this._successActivity.pipe(debounceTime(2500)).subscribe(() => this.successMessageActivity = '');

    this._errorActivity.subscribe(message => this.errorMessageActivity = message);
    this._errorActivity.pipe(debounceTime(2500)).subscribe(() => this.errorMessageActivity = '');

  }
}
